jQuery($ => {
	const context = $('body');
	initFoundation($(context))
	initFormPlugins($(context))

	$('.js-track-event', context).on('click', function () {
		var category = $(this).data('eventcategory')
			? $(this).data('eventcategory')
			: window.location.hostname
		var action = $(this).data('eventaction')
		var label = $(this).data('eventlabel')
		var group = $(this).data('eventgroup')

		var $trackingContext = $(this).closest('.tracking-context')
		if ($trackingContext.length) {
			if ($trackingContext.data('eventcategory')) {
				category = $trackingContext.data('eventcategory')
					? $trackingContext.data('eventcategory')
					: window.location.hostname
			}
			if ($trackingContext.data('eventaction')) {
				action = $trackingContext.data('eventaction')
			}
			if ($trackingContext.data('eventgroup')) {
				group = $trackingContext.data('eventgroup')
			}
		}

		trackEvent(category, action, label, group)
		trackEvent(category, action, label, 'moccamedia')

		if ($(this).data('href')) {
			var href = $(this).data('href')
			setTimeout(function () {window.location = href}, 1000)
			return false
		}
	})

	$('.fb-share', context).on('click', function () {
		fbShare(fbShareUrl)
	})

	/*
	 * Global toggle behaviour
	 *
	 * Toggle behaviour is controlled by data attributes
	 * data-container: Common container class of hidden element and trigger element; defaults to 'columns'
	 * data-target: Class of hidden element that shall be toggled; defaults to 'hidden-content'
	 * data-trigger: Class of trigger element; only needed if there are multiple trigger elements for one hidden element
	 * data-mode: Mode for toggling animation; 'slide' activates sliding animation, 'fade' actives sliding animation; default is no animation
	 */
	$(document)
		.once('dealer:document.click.js-toggle')
		.on('click', '.js-toggle', function () {
			var containerClass = $(this).data('container')
				? $(this).data('container')
				: 'columns'
			var targetClass = $(this).data('target')
				? $(this).data('target')
				: 'hidden-content'
			var group = $(this).data('toggle-group')
				? $(this).data('toggle-group')
				: ''
			var groupTargetClass = $(this).data('toggle-group-target')
				? $(this).data('toggle-group-target')
				: ''
			var triggerclass = $(this).data('trigger')
			var mode = $(this).data('mode')
			var $container = $(this).closest('.' + containerClass)
			var $target = $container.find('.' + targetClass)

			// Close all in group before toggle
			if (group) {
				var $groupTarget = $container
					.find('.' + groupTargetClass)
					.not($target)
				var $groupToggle = $container
					.find('.js-toggle[data-toggle-group="' + group + '"]')
					.not($(this))
					.removeClass('active')

				$groupTarget.hide().removeClass('active')
				$groupToggle.removeClass('active')
			}

			$(this).toggleClass('active')
			$target.toggleClass('active')

			if (mode === 'slide') {
				$target.slideToggle()
			}
			else if (mode === 'fade') {
				$target.fadeToggle()
			}
			else {
				$target.toggle()
			}

			// Toggle active class for other trigger
			if (triggerclass) {
				$container
					.find('.' + triggerclass)
					.not($(this))
					.toggleClass('active')
			}
		})

	/*
	 * Init Foundation
	 */
	function initFoundation (selector) {
		selector.foundation()
	}

	/*
	 * Init Form Plugins
	 */
	function initFormPlugins (selector) {
		if (
			!/iPhone|iPod|iPad|Android|android|playbook|silk|BlackBerry/.test(
				navigator.userAgent,
			)
		) {
			initChosen(selector.find('select').not('.webform-image-select'))
		}
	}

	/*
	 * Init Chosen
	 */
	function initChosen (selector) {
		selector.chosen({
			disable_search: true,
			inherit_select_classes: true,
		})
	}

	function trackEvent (category, action, label, group) {
		var defaultCategory = ''
		var defaultAction = 'click'
		var defaultLabel = ''

		category = category ? category : defaultCategory
		action = action ? action : defaultAction
		label = label ? label : defaultLabel

		if (typeof ga !== 'undefined') {
			if (group == 'moccamedia') {
				ga('moccamedia.send', 'event', category, action, label)
			}
			else {
				ga('send', 'event', category, action, label)
			}
		}
		if (group && typeof gtag === 'function') {
			gtag('event', action, {
				event_category: category,
				event_label: label,
				send_to: group,
			})
		}
	}

	function fbShare (url) {
		FB.ui({
			method: 'share',
			href: url,
		}, function (response) {})
	}
})
